import React from "react";
import '../../../model/index.css';

const P3 = () => {
  return (
    <div className="my-container">
      <h1 className="highlight">kaizen sushi</h1>
      <div className="section">
        <h2>Italy, Florence.</h2>
        <h2>Via Giovanni Battista Morgagni</h2>
        <p className="store-info"></p>
        <img src="./partner/3/1.pic.jpg"  alt=""/>
        <img src="./partner/3/2.pic.jpg"  alt=""/>
        <img src="./partner/3/3.pic.jpg"  alt=""/>
        <img src="./partner/3/4.pic.jpg"  alt=""/>
        <img src="./partner/3/5.pic.jpg"  alt=""/>
        <img src="./partner/3/6.pic.jpg"  alt=""/>
        <img src="./partner/3/7.pic.jpg"  alt=""/>
        <img src="./partner/3/8.pic.jpg"  alt=""/>
      </div>
    </div>
  );
};

export default P3;
